import swal from "sweetalert";
import debounce from "lodash/debounce";

function idleTimeTracker({ callBack, IdleTimeOut, message, showAlert = true }) {
  let idleTime = 0;
  let idleInterval;
  let time = 60000;
  const timeOut = IdleTimeOut || 10;
  message =
    message || `You are idle for ${timeOut} minutes, are you still active?`;

  function startIdleTimer() {
    idleTime = 0;
    startInterval();
    document.addEventListener("mousemove", resetIdleTime());
    document.addEventListener("keydown", resetIdleTime());
    document.addEventListener("scroll", resetIdleTime());
  }

  function startInterval() {
    idleInterval = setInterval(timerIncrement, time);
  }

  function timerIncrement() {
    idleTime++;
    if (idleTime === timeOut) {
      if (showAlert) {
        alert();
      }
      callBack?.(false);
      removeIdleTimer();
    }
  }

  const alert = () => {
    swal({
      title: message,
      icon: "warning",
      button: "Yes",
    }).then((isConfirm) => {
      if (isConfirm) {
        startIdleTimer();
        callBack?.(true);
      }
    });
  };

  const resetIdleTime = () => debounce(resetTime, 300);

  const resetTime = () => {
    idleTime = 0;
  };

  function removeIdleTimer() {
    clearInterval(idleInterval);
    document.removeEventListener("mousemove", resetIdleTime());
    document.removeEventListener("keydown", resetIdleTime());
    document.removeEventListener("scroll", resetIdleTime());
  }

  startIdleTimer();
  return { removeIdleTimer, startIdleTimer };
}

export default idleTimeTracker;
